import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import './products.scss';

const ProductGallerySection = ({ payload }) => {
  const { products } = payload;
  const { t } = useTranslation();

  if (!products) return null;

  return (
    <section className="products">
      <div className="products__container">
        <h2>{t(products.title)}</h2>
        <div className="products__container__cards">
          {products.images?.map((image, index) => {

            if(image.url !=null && image.url != ""){
              return (
                <a href={image.url} target='_blank'>
                  <img key={index} src={image.src} alt={`proyecto-${index + 1}`} />
                </a>
              )
            }else{
              return (
                <img key={index} src={image.src} alt={`proyecto-${index + 1}`} />
              )
            }

          })}
        </div>
        {products.cta && (
          <div className="flex__class--rowCenter">
            <a className="button--secondary" href={products.cta.href}>
              {t(products.cta.label)}
            </a>
          </div>
        )}
      </div>
    </section>
  );
};

export default ProductGallerySection;